export default "__VITE_ASSET__BVQ$dDJc__"